import { initContract } from '@ts-rest/core';
import { authContract } from './auth';
import { backOfficeContract } from './backoffice';
import { canvaContract } from './canva';
import { chatContract } from './chat';
import { consultantContract } from './consultant';
import { entityContract } from './entity';
import { fileContract } from './file';
import { integrationContract } from './integration';
import { literatureReviewContract } from './literatureReview';
import { projectContract } from './project';
import { publicApiContract } from './publicApi';
import { publicOnboardingContract, regulatoryWatchContract, } from './regulatoryWatch';
import { settingsContract } from './settings';
import { sharedKnowledgeFileContract } from './sharedKnowledgeFile';
import { sourcesContract } from './sources';
import { standardsContract } from './standards';
import { tableViewContract } from './tableView';
import { userContract } from './user';
import { websiteStatsContract } from './websiteStats';
import { workspaceContract } from './workspace';
import { workspaceFeatureContract } from './workspaceFeature';
const c = initContract();
export const contract = c.router({
    auth: authContract,
    users: userContract,
    file: fileContract,
    workspaces: workspaceContract,
    entity: entityContract,
    chat: chatContract,
    canva: canvaContract,
    backOffice: backOfficeContract,
    consultant: consultantContract,
    sharedKnowledgeFile: sharedKnowledgeFileContract,
    integration: integrationContract,
    settings: settingsContract,
    literatureReview: literatureReviewContract,
    project: projectContract,
    workspaceFeature: workspaceFeatureContract,
    sources: sourcesContract,
    tableView: tableViewContract,
    regulatoryWatch: regulatoryWatchContract,
    publicOnboarding: publicOnboardingContract,
    standards: standardsContract,
    websiteStats: websiteStatsContract,
    publicApi: publicApiContract,
});
// Export individual contracts for direct access
export { authContract } from './auth';
export { backOfficeContract } from './backoffice';
export { consultantContract } from './consultant';
export { canvaContract } from './canva';
export { chatContract } from './chat';
export { entityContract } from './entity';
export { fileContract } from './file';
export { integrationContract } from './integration';
export { literatureReviewContract } from './literatureReview';
export { projectContract } from './project';
export { settingsContract } from './settings';
export { sharedKnowledgeFileContract } from './sharedKnowledgeFile';
export { regulatoryWatchContract } from './regulatoryWatch';
export { standardsContract } from './standards';
export { tableViewContract } from './tableView';
export { userContract } from './user';
export { websiteStatsContract } from './websiteStats';
export { workspaceContract } from './workspace';
export { publicApiContract } from './publicApi';
export { workspaceFeatureContract } from './workspaceFeature';
export * from './auth';
export * from './backoffice';
export * from './consultant';
export * from './canva';
export * from './chat';
export * from './entity';
export * from './file';
export * from './integration';
export * from './literatureReview';
export * from './pagination';
export * from './project';
export * from './settings';
export * from './sharedKnowledgeFile';
export * from './sources';
export * from './regulatoryWatch';
export * from './standards';
export * from './tableView';
export * from './user';
export * from './websiteStats';
export * from './publicApi';
export * from './workspace';
export * from './workspaceFeature';
//# sourceMappingURL=index.js.map